export enum ESegment {
  SEA = 'Sea',
  ROAD = 'Road',
  AIR = 'Air',
  RAIL = 'Rail',
}
